import { getQRCode } from '@/utils/common.js';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      config: {
        'yingshang': {
          name: '颍上县农村产权交易中心',
          address: '颍上县政务服务中心（新）一楼西侧',
          phone: '15715652721',
          email: 'ysnccqjy@126.com',
          downloadText: '扫码下载颍上产权APP'
        },
        'linquan': {
          name: '临泉县农村产权交易中心',
          address: '临泉县霞光大道与光明路交叉口晶宫广场东100米',
          phone: '15715652721',
          email: 'lqnccqjy@126.com',
          downloadText: '扫码下载临泉产权APP'
        },
        'hnnt': {
          name: '河南农投农业大数据科技有限公司',
          address: '郑州市郑东新区如意东路36号',
          phone: '',
          email: 'ntsk@hnntgroup.cn',
          downloadText: ''
        }
      }
    };
  },
  computed: {
    ...mapGetters([
      'getTenantParams'
    ]),
    active() {
      return this.getTenantParams.href;
    }
  },
  methods: {
    getQRCode,
    goDisclaimer () {
      this.$router.push('/disclaimer-detail/disclaimer');
    }
  }
};
